/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
// Mantine
import {
	Accordion,
	ActionIcon,
	Center,
	Menu,
} from '@mantine/core';

// Styles
import classes from './Sites.module.css';

// Icons
import {
	IconDotsVertical,
	IconPencil,
	IconTrash,
} from '@tabler/icons-react';

// I18n
import { useTranslation } from 'react-i18next';

/* -------------------------------------------------------------------------- */
/*                                    Typs                                    */
/* -------------------------------------------------------------------------- */
type SiteAccordionProps = {
	label: string;
	panel: JSX.Element;
	handleEdit: () => void;
	handleDelete: () => void;
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const SiteAccordion = (
	props: SiteAccordionProps
) => {
	/* ******************************** HOOKS ******************************* */
	const { t } = useTranslation();
	/* ******************************** RENDERING ******************************* */
	return (
		<Accordion
			classNames={classes}
			flex={1}
			chevronPosition="left"
		>
			<Accordion.Item value={props.label}>
				<Center>
					<Accordion.Control>
						{props.label}
					</Accordion.Control>
					<Menu
						disabled
						shadow="xs"
						position="bottom-end"
					>
						<Menu.Target>
							<ActionIcon
								disabled
								size="lg"
								variant="subtle"
								color="gray"
							>
								<IconDotsVertical size="1rem" />
							</ActionIcon>
						</Menu.Target>
						<Menu.Dropdown>
							<Menu.Item
								onClick={(event) => {
									event.stopPropagation();
									props.handleEdit();
								}}
								color="var(--mantine-color-black)"
								className={classes.item}
								leftSection={
									<IconPencil className={classes.icon} />
								}
							>
								{t('global.edit')}
							</Menu.Item>
							<Menu.Item
								onClick={(event) => {
									event.stopPropagation();
									props.handleDelete();
								}}
								color="var(--mantine-color-error)"
								className={classes.item}
								leftSection={
									<IconTrash className={classes.icon} />
								}
							>
								{t('global.delete')}
							</Menu.Item>
						</Menu.Dropdown>
					</Menu>
				</Center>
				<Accordion.Panel>{props.panel}</Accordion.Panel>
			</Accordion.Item>
		</Accordion>
	);
};
